import * as Sentry from '@sentry/react';
import './gas-price-list.scss';
import type { IGasPriceModel, ITransferFees, ICryptoCurrency } from '../../interfaces/gas-price.model';
import { GasPrice } from '../gas-price/GasPrice';

export function GasPriceList({
  data,
  localizations,
  loading,
  tokenPrice,
  selectedNetwork,
}: {
  data: IGasPriceModel | null;
  localizations: Map<string, string>;
  loading: boolean;
  tokenPrice: ITransferFees | null;
  selectedNetwork: ICryptoCurrency | undefined;
}) {
  const pricesList = data?.gasPrices?.map((item) => (
    <GasPrice
      key={item.type}
      gasPrice={{
        ...item,
        fiatUnits: data?.fiatUnits ?? '',
        count: data?.gasPrices.length,
      }}
      localizations={localizations}
      loading={loading}
      tokenPrice={tokenPrice}
      selectedNetwork={selectedNetwork}
    />
  ));

  return <Sentry.ErrorBoundary>{pricesList}</Sentry.ErrorBoundary>;
}
